import * as React from 'react';

const ForsiaFacebookIcon = ({
  height = 32,
  width = 32,
}: {
  height: number;
  width: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_14134_53116)">
      <path
        d="M22 0H10C4.47715 0 0 4.47715 0 10V22C0 27.5228 4.47715 32 10 32H22C27.5228 32 32 27.5228 32 22V10C32 4.47715 27.5228 0 22 0Z"
        fill="#C5E86C"
      />
      <path
        d="M14 13.33H12V16H14V24H17.33V16H19.76L20 13.33H17.33V12.22C17.33 11.58 17.46 11.33 18.07 11.33H19.99V8H17.45C15.05 8 13.99 9.06 13.99 11.08V13.34L14 13.33Z"
        fill="#04330F"
      />
    </g>
    <defs>
      <clipPath id="clip0_14134_53116">
        <rect width={width} height={height} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ForsiaFacebookIcon;
